module.exports = __webpack_public_path__ + "static/media/distinctive-assets-1x.b68c2df0.webp";